import PipelineVisualization from "../../components/employeer/pipeline-visualization/pipeline-visualization-reports";

const PiplelineVisualizationPage = () => {
  return <PipelineVisualization />;
};

export default PiplelineVisualizationPage;
